import {
  Colors,
  useAuthStore,
  useSafeLocalSearchParams,
} from '@sunrise-ui/primitives';
import { Redirect } from 'expo-router';
import React, { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';

type LoginParams = {
  email?: string;
  redirect?: string;
};

/**
 * Login route for handling force login deep links.
 * Sets force login intent in store then redirects to destination.
 *
 * Deep link formats:
 * - With email: communiful://login?email=test@example.com&redirect=/communities/123
 * - Without email: communiful://login?redirect=/communities/123
 */
export function LoginRedirect() {
  const { email, redirect } = useSafeLocalSearchParams<LoginParams>();
  const { setForceLogin } = useAuthStore();
  const [isReady, setIsReady] = useState(false);

  const destination = (redirect as string) || '/';

  // Set force login in useEffect to avoid setState during render
  useEffect(() => {
    setForceLogin({ email });
    setIsReady(true);
  }, [email, redirect, setForceLogin]);

  // Only redirect after we've set the force login state
  if (!isReady) {
    return <View style={styles.loadingView} />;
  }

  return <Redirect href={destination} />;
}

const styles = StyleSheet.create({
  loadingView: {
    flex: 1,
    backgroundColor: Colors.purple0,
  },
});
